// extracted by mini-css-extract-plugin
export default {"price-input":"_2Dhf8","priceInput":"_2Dhf8","premium-selected":"_30mTJ","premiumSelected":"_30mTJ"};